import { DEFAULT_ENTITY_STATS, IEntityStats } from '../types/entity.types';

export interface PlayerConfig {
  configId: string;
  stats: IEntityStats;
}

/** Temporary universal base kit. Equipment stats are layered on top later. */
export const DEFAULT_PLAYER_CONFIG: PlayerConfig = {
  configId: 'player',
  stats: {
    ...DEFAULT_ENTITY_STATS,
    maxLife: 20,
    physicalAttack: 11,
    physicalDefense: 10,
    magicAttack: 11,
    magicDefense: 10,
    moveSpeed: 100,
    maxShield: 10,
    viewRange: 5,
  },
};
